module.exports = __webpack_public_path__ + "合作12.png?db97f66ca9ceb52f5a4960e0b658311c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/合作12.png
// module id = 654
// module chunks = 0